export default __webpack_public_path__ + "static/media/profile.95a46214.svg";